import { ref, type Ref } from 'vue';

/**
 * A type-ahead's own suggestions: what its latest lookup answered.
 *
 * Each type-ahead keeps its own. Several can be on screen at once, and they used to share one
 * list in the store — so each showed what another had last looked up, under whatever scope that
 * one had.
 *
 * Lookups can land out of order — one per keyup — so only the latest may fill the list. A lookup
 * that answers with nothing (it failed, or could not be made) leaves the list as it was.
 */
export function useTypeAheadLookup<T>(lookUp: (text: string) => Promise<T[] | null | undefined | void>) {
    const choices = ref<T[]>([]) as Ref<T[]>;
    let latestLookUp = 0;

    const onKeyUp = async (event: any) => {
        const sequence = ++latestLookUp;
        const found = await lookUp(event?.target?.value ?? '');
        if (sequence === latestLookUp && found) choices.value = found;
    };

    return { choices, onKeyUp };
}
